
import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
	import { PreQuestion } from '@/types';
import {MutationType} from "@/enums";

	@Component({})
	export default class PreQuestionField extends Vue {
		@Prop() data!: PreQuestion;

		@Emit()
		private toggleAnswer(): void {
			this.data.answer = !this.data.answer;
		}

	}
